import { PhoneOff } from "lucide-react";
import { Button } from "@shared/ui/Button";
import { useBreakpoint } from "@shared/hooks/useBreakpoint";

export type Props = {
  onClick: () => void;
};

export function VideoUIControlsEndMeeting({ onClick }: Props) {
  const isMdScreen = useBreakpoint("md");

  return (
    <Button iconComponent={PhoneOff} onClick={onClick} destructive theme="dark">
      {isMdScreen ? "Leave" : ""}
    </Button>
  );
}

export default VideoUIControlsEndMeeting;
